__turbopack_context__.v({
  "pillItem": "mpDcRG_pillItem",
  "pills": "mpDcRG_pills",
  "promptLine": "mpDcRG_promptLine",
  "promptLineText": "mpDcRG_promptLineText",
  "root": "mpDcRG_root",
});
